import { UserIcon } from "@heroicons/react/24/solid";
import Image from "next/image";

import { User, UserNoDates } from "@/types/types";

export function UserImage({ user }: { user: User | UserNoDates }) {
  return (
    <>
      {user.image === null ?
        <UserIcon className="h-8 w-8 shrink-0 text-gray-900" />
      : <Image
          src={user.image}
          alt={"User profile image"}
          width={32}
          height={32}
          quality={100}
          className="rounded-full"
          unoptimized
        />
      }
    </>
  );
}
